export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  Date: { input: any; output: any; }
  JsonValue: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
};

export type AuditInfo = {
  __typename?: 'AuditInfo';
  created: Scalars['LocalDateTime']['output'];
  createdBy: Scalars['String']['output'];
  updated: Scalars['LocalDateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AvailableParamValuePayload = {
  __typename?: 'AvailableParamValuePayload';
  labels?: Maybe<Scalars['JsonValue']['output']>;
  paramInputType?: Maybe<ParamTypeEnum>;
  possibleValues?: Maybe<Array<Scalars['Int']['output']>>;
  usedValue?: Maybe<Scalars['Int']['output']>;
};

export type Body = CodetableDto & {
  __typename?: 'Body';
  /** Contains unique code of the body */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
  vehicleType: VehicleType;
};

export type BodyCreateDto = {
  /**
   * Contains unique string value chosen by user in the system.
   * eg.: COMBI, CHASI
   * system validates combination code-vehicleTypeId
   * this value is automatically converted to uppercase
   */
  code: Scalars['ID']['input'];
  labels?: InputMaybe<Array<CodetableLabelCreateDto>>;
  vehicleTypeId: Scalars['ID']['input'];
};

export type BodyPayload = ResponsePayload & {
  __typename?: 'BodyPayload';
  data?: Maybe<Body>;
  errors?: Maybe<Array<BusinessError>>;
};

export type BodyUpdateDto = {
  /**
   * Contains unique identifier in the system
   * this value is automatically converted to uppercase
   */
  id: Scalars['ID']['input'];
  newLabels?: InputMaybe<Array<CodetableLabelCreateDto>>;
  state?: InputMaybe<CodetableStateEnum>;
  updatedLabels?: InputMaybe<Array<CodetableLabelUpdateDto>>;
  vehicleTypeId: Scalars['ID']['input'];
};

export type Bonus = {
  __typename?: 'Bonus';
  auditInfo: AuditInfo;
  brand?: Maybe<Brand>;
  engine?: Maybe<Scalars['String']['output']>;
  equipment?: Maybe<Scalars['String']['output']>;
  forCrn?: Maybe<Scalars['Boolean']['output']>;
  forPhysicalPerson?: Maybe<Scalars['Boolean']['output']>;
  fourDriveWheel?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  unit: BonusUnitEnum;
  validTo?: Maybe<Scalars['LocalDate']['output']>;
  value: Scalars['BigDecimal']['output'];
  vehicleType?: Maybe<VehicleType>;
};

export type BonusCreateInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  forCrn?: InputMaybe<Scalars['Boolean']['input']>;
  forPhysicalPerson?: InputMaybe<Scalars['Boolean']['input']>;
  fourDriveWheel?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unit: BonusUnitEnum;
  validTo?: InputMaybe<Scalars['LocalDate']['input']>;
  value: Scalars['BigDecimal']['input'];
  vehicleTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type BonusFilter = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  forCrn?: InputMaybe<Scalars['Boolean']['input']>;
  forPhysicalPerson?: InputMaybe<Scalars['Boolean']['input']>;
  fourDriveWheel?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  validTo?: InputMaybe<Scalars['LocalDate']['input']>;
  vehicleTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type BonusPayload = ResponsePayload & {
  __typename?: 'BonusPayload';
  bonus?: Maybe<Bonus>;
  errors?: Maybe<Array<BusinessError>>;
};

export enum BonusUnitEnum {
  Czk = 'CZK',
  Percentage = 'PERCENTAGE'
}

export type BonusUpdateInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  forCrn?: InputMaybe<Scalars['Boolean']['input']>;
  forPhysicalPerson?: InputMaybe<Scalars['Boolean']['input']>;
  fourDriveWheel?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unit: BonusUnitEnum;
  validTo?: InputMaybe<Scalars['LocalDate']['input']>;
  value: Scalars['BigDecimal']['input'];
  vehicleTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type Brand = CodetableDto & {
  __typename?: 'Brand';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export enum BrandEnum {
  Ford = 'FORD',
  Skoda = 'SKODA',
  Toyota = 'TOYOTA',
  Volvo = 'VOLVO',
  Vwg = 'VWG'
}

export type BrandPayload = ResponsePayload & {
  __typename?: 'BrandPayload';
  data?: Maybe<Brand>;
  errors?: Maybe<Array<BusinessError>>;
};

export type BusinessError = {
  __typename?: 'BusinessError';
  code?: Maybe<Scalars['String']['output']>;
};

export type Calculation = {
  __typename?: 'Calculation';
  calculationResults: Array<CalculationResult>;
  modelKey: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
};

export enum CalculationDomainEnum {
  Credit = 'CREDIT',
  Leasing = 'LEASING',
  Skoda = 'SKODA'
}

export type CalculationInput = {
  claimFreeMonths?: InputMaybe<Scalars['Int']['input']>;
  clientAge?: InputMaybe<Scalars['Int']['input']>;
  domain: CalculationDomainEnum;
  insuranceDeductible?: InputMaybe<Scalars['Int']['input']>;
  insuranceId?: InputMaybe<Scalars['Int']['input']>;
  insurancePackageId?: InputMaybe<Scalars['Int']['input']>;
  insuranceWindshieldLimit?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  modelKey: Scalars['String']['input'];
  modelYear: Scalars['Int']['input'];
  originalModelPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  params: Array<CalculationParams>;
  productId?: InputMaybe<Scalars['String']['input']>;
  regDateFirst?: InputMaybe<Scalars['Date']['input']>;
  totalModelPrice: Scalars['BigDecimal']['input'];
  vehicleType: CalculationVehicleTypeEnum;
};

export type CalculationParams = {
  advancePayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  finalUnevenInstallment?: InputMaybe<Scalars['Int']['input']>;
  paymentPeriod: Scalars['Int']['input'];
  totalKmPerYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculationPayload = ResponsePayload & {
  __typename?: 'CalculationPayload';
  calculation: Calculation;
  errors?: Maybe<Array<BusinessError>>;
  productDisclaimer?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
};

export type CalculationProductsInput = {
  domain: CalculationDomainEnum;
  modelKey: Scalars['String']['input'];
  modelYear: Scalars['Int']['input'];
  regDateFirst?: InputMaybe<Scalars['Date']['input']>;
  vehicleType: CalculationVehicleTypeEnum;
};

export type CalculationResult = {
  __typename?: 'CalculationResult';
  advancePaymentParam: AvailableParamValuePayload;
  apr?: Maybe<Scalars['BigDecimal']['output']>;
  claimFreeMonthsParam?: Maybe<AvailableParamValuePayload>;
  clientAgeParam?: Maybe<AvailableParamValuePayload>;
  finalUnevenInstallmentParam: AvailableParamValuePayload;
  insuranceDeductibleParam: AvailableParamValuePayload;
  insuranceIdParam: AvailableParamValuePayload;
  insurancePackageIdParam: AvailableParamValuePayload;
  insuranceWindshieldLimitParam: AvailableParamValuePayload;
  interestRate?: Maybe<Scalars['BigDecimal']['output']>;
  monthlyInstalment: Scalars['BigDecimal']['output'];
  monthlyInstalmentOnInsuranceOnly?: Maybe<Scalars['BigDecimal']['output']>;
  paymentPeriodParam: AvailableParamValuePayload;
  totalKmPerYearParam: AvailableParamValuePayload;
};

export enum CalculationVehicleTypeEnum {
  New = 'NEW',
  Used = 'USED'
}

export type CardColorDeletePayload = DeletePayload & {
  __typename?: 'CardColorDeletePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type CodetableCreateDto = {
  /**
   * Contains unique string value chosen by user in the system.
   * eg.: SKODA, FORD
   * system validates uniqueness of this value
   * this value is automatically converted to uppercase
   */
  id: Scalars['ID']['input'];
  labels?: InputMaybe<Array<CodetableLabelCreateDto>>;
};

export type CodetableDto = {
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type CodetableLabelCreateDto = {
  label: Scalars['String']['input'];
  language: LanguageEnum;
};

export type CodetableLabelUpdateDto = {
  label: Scalars['String']['input'];
  language: LanguageEnum;
};

export enum CodetableStateEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type CodetableUpdateDto = {
  /**
   * Contains unique value to identify existing entry n the system
   * EG: SKODA
   * ID value is automatically converted to uppercase
   */
  id: Scalars['ID']['input'];
  newLabels?: InputMaybe<Array<CodetableLabelCreateDto>>;
  state?: InputMaybe<CodetableStateEnum>;
  updatedLabels?: InputMaybe<Array<CodetableLabelUpdateDto>>;
};

export type Color = CodetableDto & {
  __typename?: 'Color';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type ColorPayload = ResponsePayload & {
  __typename?: 'ColorPayload';
  data?: Maybe<Color>;
  errors?: Maybe<Array<BusinessError>>;
};

export type ColorType = CodetableDto & {
  __typename?: 'ColorType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type ColorTypePayload = ResponsePayload & {
  __typename?: 'ColorTypePayload';
  data?: Maybe<ColorType>;
  errors?: Maybe<Array<BusinessError>>;
};

export type CountryOfOrigin = CodetableDto & {
  __typename?: 'CountryOfOrigin';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type CountryOfOriginPayload = ResponsePayload & {
  __typename?: 'CountryOfOriginPayload';
  data?: Maybe<CountryOfOrigin>;
  errors?: Maybe<Array<BusinessError>>;
};

export type Credit = {
  __typename?: 'Credit';
  creditGroups?: Maybe<Array<Maybe<CreditGroup>>>;
  extension?: Maybe<Scalars['String']['output']>;
  servicePackage: ServicePackage;
};

export type CreditGroup = {
  __typename?: 'CreditGroup';
  creditCalculationParams?: Maybe<FinanceCalculationParams>;
  items?: Maybe<Array<CreditGroupItem>>;
  type: CreditTypeEnum;
};

export type CreditGroupInput = {
  creditCalculationParams?: InputMaybe<FinanceCalculationParamsInput>;
  items?: InputMaybe<Array<CreditGroupItemInput>>;
  type: CreditTypeEnum;
};

export type CreditGroupItem = {
  __typename?: 'CreditGroupItem';
  advancePayment?: Maybe<Scalars['BigDecimal']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  monthlyInstalment?: Maybe<Scalars['BigDecimal']['output']>;
};

export type CreditGroupItemInput = {
  advancePayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  monthlyInstalment?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type CreditInput = {
  creditGroups?: InputMaybe<Array<InputMaybe<CreditGroupInput>>>;
  extension?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['ID']['input'];
};

export enum CreditTypeEnum {
  Crn = 'CRN',
  PhysicalPerson = 'PHYSICAL_PERSON'
}

export enum CurrencyEnum {
  Czk = 'CZK',
  Eur = 'EUR'
}

export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  dataType: CustomAttributeDataTypeEnum;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export enum CustomAttributeDataTypeEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Int = 'INT',
  String = 'STRING'
}

export type CustomAttributeInput = {
  dataType: CustomAttributeDataTypeEnum;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type DateFilter = {
  from?: InputMaybe<Scalars['LocalDate']['input']>;
  to?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type DateTimeFilter = {
  /** Attributed used to passed `from` date-time. Expects ISO 8601 format. */
  from?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Attributed used to passed `to` date-time. Expects ISO 8601 format. */
  to?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type DeferredCredit = {
  __typename?: 'DeferredCredit';
  deferredCreditGroups?: Maybe<Array<Maybe<DeferredCreditGroup>>>;
  extension?: Maybe<Scalars['String']['output']>;
  servicePackage: ServicePackage;
};

export type DeferredCreditGroup = {
  __typename?: 'DeferredCreditGroup';
  items?: Maybe<Array<DeferredCreditGroupItem>>;
  type: CreditTypeEnum;
};

export type DeferredCreditGroupInput = {
  items?: InputMaybe<Array<DeferredCreditGroupItemInput>>;
  type: CreditTypeEnum;
};

export type DeferredCreditGroupItem = {
  __typename?: 'DeferredCreditGroupItem';
  advancePayment?: Maybe<Scalars['BigDecimal']['output']>;
  deferredPayment?: Maybe<Scalars['BigDecimal']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  monthlyInstalment?: Maybe<Scalars['BigDecimal']['output']>;
  purchasePrice?: Maybe<Scalars['BigDecimal']['output']>;
};

export type DeferredCreditGroupItemInput = {
  advancePayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  deferredPayment?: InputMaybe<Scalars['BigDecimal']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  monthlyInstalment?: InputMaybe<Scalars['BigDecimal']['input']>;
  purchasePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type DeferredCreditInput = {
  deferredCreditGroups?: InputMaybe<Array<InputMaybe<DeferredCreditGroupInput>>>;
  extension?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['ID']['input'];
};

export type DeletePayload = {
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  auditInfo: AuditInfo;
  category: EquipmentCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentCategory = CodetableDto & {
  __typename?: 'EquipmentCategory';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type EquipmentCategoryPayload = ResponsePayload & {
  __typename?: 'EquipmentCategoryPayload';
  data?: Maybe<EquipmentCategory>;
  errors?: Maybe<Array<BusinessError>>;
};

export type EquipmentCreateInput = {
  categoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type EquipmentItem = {
  __typename?: 'EquipmentItem';
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  equipment: Equipment;
  id: Scalars['ID']['output'];
};

export type EquipmentItemCreateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
  modelEquipmentInputId: Scalars['ID']['input'];
};

export type EquipmentItemDeleteInput = {
  id: Scalars['ID']['input'];
};

export type EquipmentItemPayload = ResponsePayload & {
  __typename?: 'EquipmentItemPayload';
  equipmentItem?: Maybe<EquipmentItem>;
  errors?: Maybe<Array<BusinessError>>;
};

export type EquipmentItemUpdateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type EquipmentPayload = ResponsePayload & {
  __typename?: 'EquipmentPayload';
  equipment?: Maybe<Equipment>;
  errors?: Maybe<Array<BusinessError>>;
};

export type EquipmentUpdateInput = {
  categoryId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  id: Scalars['ID']['output'];
  inserted?: Maybe<Scalars['Date']['output']>;
  system: Scalars['String']['output'];
};

export type ExternalSystemInput = {
  id: Scalars['ID']['input'];
  inserted?: InputMaybe<Scalars['Date']['input']>;
  system: Scalars['String']['input'];
};

export type ExtraEquipmentItem = {
  __typename?: 'ExtraEquipmentItem';
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['BigDecimal']['output']>;
};

export type ExtraEquipmentItemInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type FinanceCalculationParams = {
  __typename?: 'FinanceCalculationParams';
  automaticCalculation: Scalars['Boolean']['output'];
  carPriceDiscount: Scalars['BigDecimal']['output'];
  claimFreeMonths?: Maybe<Scalars['Int']['output']>;
  clientAge?: Maybe<Scalars['Int']['output']>;
  contraAccount?: Maybe<Scalars['Boolean']['output']>;
  insuranceDeductible: Scalars['Int']['output'];
  insuranceId: Scalars['Int']['output'];
  insurancePackageId: Scalars['Int']['output'];
  insuranceWindshieldLimit: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  regDateFirst?: Maybe<Scalars['LocalDate']['output']>;
  totalModelPrice: Scalars['BigDecimal']['output'];
};

export type FinanceCalculationParamsInput = {
  automaticCalculation: Scalars['Boolean']['input'];
  carPriceDiscount: Scalars['BigDecimal']['input'];
  claimFreeMonths?: InputMaybe<Scalars['Int']['input']>;
  clientAge?: InputMaybe<Scalars['Int']['input']>;
  contraAccount?: Scalars['Boolean']['input'];
  insuranceDeductible: Scalars['Int']['input'];
  insuranceId: Scalars['Int']['input'];
  insurancePackageId: Scalars['Int']['input'];
  insuranceWindshieldLimit: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  regDateFirst?: InputMaybe<Scalars['LocalDate']['input']>;
  totalModelPrice: Scalars['BigDecimal']['input'];
};

export type FinanceGroup = {
  __typename?: 'FinanceGroup';
  credit?: Maybe<Credit>;
  deferredCredit?: Maybe<DeferredCredit>;
  groupPrice: Scalars['BigDecimal']['output'];
  lease?: Maybe<Leasing>;
};

export type FinanceGroupInput = {
  credit?: InputMaybe<CreditInput>;
  deferredCredit?: InputMaybe<DeferredCreditInput>;
  groupColorPrice: Scalars['BigDecimal']['input'];
  lease?: InputMaybe<LeasingInput>;
};

export type FinanceProduct = {
  __typename?: 'FinanceProduct';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  type?: Maybe<FinanceProductTypeEnum>;
};

export enum FinanceProductTypeEnum {
  Credit = 'Credit',
  Lease = 'Lease'
}

export enum FinanceTypeEnum {
  Credit = 'CREDIT',
  DeferredCredit = 'DEFERRED_CREDIT',
  Leasing = 'LEASING'
}

export type FuelType = CodetableDto & {
  __typename?: 'FuelType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export enum FuelTypeEnum {
  Cng = 'CNG',
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gasoline = 'GASOLINE',
  Hybrid = 'HYBRID',
  Phev = 'PHEV'
}

export type FuelTypePayload = ResponsePayload & {
  __typename?: 'FuelTypePayload';
  data?: Maybe<FuelType>;
  errors?: Maybe<Array<BusinessError>>;
};

export type GenerateAccessTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type Image = ImageI & {
  __typename?: 'Image';
  cardColorId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
};

export type ImageBasic = ImageI & {
  __typename?: 'ImageBasic';
  cardColorId?: Maybe<Scalars['ID']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
};

export type ImageDeleteInput = {
  imageId: Scalars['ID']['input'];
};

export type ImageDeletePayload = DeletePayload & {
  __typename?: 'ImageDeletePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ImageI = {
  cardColorId?: Maybe<Scalars['ID']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
};

export type ImagePayload = ResponsePayload & {
  __typename?: 'ImagePayload';
  errors?: Maybe<Array<BusinessError>>;
  imageId: Scalars['ID']['output'];
};

export type ImageUploadInput = {
  cardColorId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type ImportChangedProperties = {
  __typename?: 'ImportChangedProperties';
  newValue?: Maybe<Scalars['JsonValue']['output']>;
  oldValue?: Maybe<Scalars['JsonValue']['output']>;
  property: Scalars['String']['output'];
};

export enum ImportStateEnum {
  CardAwaitingApproval = 'CARD_AWAITING_APPROVAL',
  CardPublished = 'CARD_PUBLISHED',
  NoCard = 'NO_CARD'
}

export type ImportedUsedVehicleDefinition = {
  __typename?: 'ImportedUsedVehicleDefinition';
  auctionPrice?: Maybe<Scalars['Float']['output']>;
  body?: Maybe<Scalars['ID']['output']>;
  brandId: Scalars['ID']['output'];
  changedProperties: Array<ImportChangedProperties>;
  color?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['ID']['output']>;
  cubicCapacity?: Maybe<Scalars['Float']['output']>;
  cubicCapacityDescription?: Maybe<Scalars['String']['output']>;
  currency: CurrencyEnum;
  doorsNumber?: Maybe<Scalars['Int']['output']>;
  driveWheel?: Maybe<Scalars['String']['output']>;
  emission?: Maybe<Scalars['Float']['output']>;
  emissionUntil?: Maybe<Scalars['Date']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  equipment?: Maybe<Scalars['JsonValue']['output']>;
  fourDriveWheel?: Maybe<Scalars['Boolean']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['ID']['output']>;
  imageUrls: Array<Scalars['String']['output']>;
  importAdvertisementUrl: Scalars['String']['output'];
  importState: ImportStateEnum;
  imported: Scalars['LocalDateTime']['output'];
  importedFromSystem: Scalars['String']['output'];
  intoOperation?: Maybe<Scalars['Date']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  mileage: Scalars['Int']['output'];
  model?: Maybe<Scalars['String']['output']>;
  modelKey?: Maybe<Scalars['String']['output']>;
  modelKeyExtension?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  newVehiclePrice?: Maybe<Scalars['Float']['output']>;
  noCrashFlag?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfPallets?: Maybe<Scalars['Int']['output']>;
  ownerCount: Scalars['Int']['output'];
  power?: Maybe<Scalars['String']['output']>;
  price: Scalars['BigDecimal']['output'];
  range?: Maybe<Scalars['Int']['output']>;
  refVehicle?: Maybe<Scalars['Boolean']['output']>;
  seats?: Maybe<Scalars['Int']['output']>;
  seller?: Maybe<UsedVehicleSeller>;
  serviceBookFlag?: Maybe<Scalars['Boolean']['output']>;
  shifts?: Maybe<Scalars['Int']['output']>;
  stkUntil?: Maybe<Scalars['Date']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  transmissionType?: Maybe<Scalars['ID']['output']>;
  trunkLength?: Maybe<Scalars['Float']['output']>;
  trunkSpace?: Maybe<Scalars['Float']['output']>;
  vatExpelFlag?: Maybe<Scalars['Boolean']['output']>;
  vehicleState?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['ID']['output']>;
  vin: Scalars['String']['output'];
  wheelbase?: Maybe<Scalars['ID']['output']>;
};

export type ImportedVehicleDefinitionFilter = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  importStates?: InputMaybe<Array<InputMaybe<ImportStateEnum>>>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedVehicleDefinitionPage = {
  __typename?: 'ImportedVehicleDefinitionPage';
  data: Array<ImportedUsedVehicleDefinition>;
  pageInfo: PageInfo;
};

export type InStoreVehicleCardInput = {
  cardColorId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
  commission: Scalars['String']['input'];
  deliveryDate: VehicleDeliveryInput;
  offerValidTo?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type JwtPayload = {
  __typename?: 'JwtPayload';
  jwt: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
};

/** Contains Language supported values in the system */
export enum LanguageEnum {
  Cs = 'CS'
}

export type Leasing = {
  __typename?: 'Leasing';
  contraAccount?: Maybe<Scalars['Boolean']['output']>;
  leasingGroups?: Maybe<Array<Maybe<LeasingGroup>>>;
  servicePackage: ServicePackage;
};

export type LeasingGroup = {
  __typename?: 'LeasingGroup';
  items?: Maybe<Array<LeasingGroupItem>>;
  leasingCalculationParams?: Maybe<FinanceCalculationParams>;
  type: LeasingTypeEnum;
};

export type LeasingGroupInput = {
  items?: InputMaybe<Array<LeasingGroupItemInput>>;
  leasingCalculationParams?: InputMaybe<FinanceCalculationParamsInput>;
  type: LeasingTypeEnum;
};

export type LeasingGroupItem = {
  __typename?: 'LeasingGroupItem';
  month?: Maybe<Scalars['Int']['output']>;
  monthlyInstalment?: Maybe<Scalars['BigDecimal']['output']>;
  totalKmPerYear?: Maybe<Scalars['Int']['output']>;
};

export type LeasingGroupItemInput = {
  month?: InputMaybe<Scalars['Int']['input']>;
  monthlyInstalment?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalKmPerYear?: InputMaybe<Scalars['Int']['input']>;
};

export type LeasingInput = {
  contraAccount: Scalars['Boolean']['input'];
  leasingGroups?: InputMaybe<Array<InputMaybe<LeasingGroupInput>>>;
  serviceId: Scalars['ID']['input'];
};

export enum LeasingTypeEnum {
  ContraAccountCrn = 'CONTRA_ACCOUNT_CRN',
  ContraAccountPhysicalPerson = 'CONTRA_ACCOUNT_PHYSICAL_PERSON',
  Crn = 'CRN',
  PhysicalPerson = 'PHYSICAL_PERSON'
}

export enum LocalizationEnum {
  Cs = 'CS',
  En = 'EN'
}

export type MarketingTag = CodetableDto & {
  __typename?: 'MarketingTag';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export enum MarketingTagEnum {
  MarketLowestPrice = 'MARKET_LOWEST_PRICE',
  Partner = 'PARTNER',
  Reserved = 'RESERVED',
  TopOffer = 'TOP_OFFER'
}

export type MarketingTagPayload = ResponsePayload & {
  __typename?: 'MarketingTagPayload';
  data?: Maybe<MarketingTag>;
  errors?: Maybe<Array<BusinessError>>;
};

export type ModelColor = {
  __typename?: 'ModelColor';
  auditInfo: AuditInfo;
  color: Color;
  colorType: ColorType;
  id: Scalars['ID']['output'];
  modelDefinitionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['BigDecimal']['output'];
};

export type ModelColorCreateInput = {
  colorId: Scalars['ID']['input'];
  colorTypeId: Scalars['ID']['input'];
  modelDefinitionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  price: Scalars['BigDecimal']['input'];
};

export type ModelColorDeleteInput = {
  id: Scalars['ID']['input'];
};

export type ModelColorDeletePayload = DeletePayload & {
  __typename?: 'ModelColorDeletePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ModelColorPayload = ResponsePayload & {
  __typename?: 'ModelColorPayload';
  errors?: Maybe<Array<BusinessError>>;
  modelColor?: Maybe<ModelColor>;
};

export type ModelColorUpdateInput = {
  colorId: Scalars['ID']['input'];
  colorTypeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  price: Scalars['BigDecimal']['input'];
};

export type ModelDefinition = {
  __typename?: 'ModelDefinition';
  auditInfo: AuditInfo;
  brand: Brand;
  colors?: Maybe<Array<ModelColor>>;
  id: Scalars['ID']['output'];
  line: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  vehicleType: VehicleType;
};

export type ModelDefinitionCopyInput = {
  modelYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelDefinitionCreateInput = {
  brandId: Scalars['ID']['input'];
  line?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  vehicleTypeCode: Scalars['String']['input'];
};

export type ModelDefinitionPayload = ResponsePayload & {
  __typename?: 'ModelDefinitionPayload';
  errors?: Maybe<Array<BusinessError>>;
  modelDefinition?: Maybe<ModelDefinition>;
};

export type ModelDefinitionUpdateInput = {
  brandId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  line: Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelYear: Scalars['Int']['input'];
  vehicleTypeCode: Scalars['String']['input'];
};

export type ModelEquipment = {
  __typename?: 'ModelEquipment';
  auditInfo: AuditInfo;
  equipments?: Maybe<Array<EquipmentItem>>;
  id: Scalars['ID']['output'];
  modelDefinitionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortNumber: Scalars['Int']['output'];
};

export type ModelEquipmentCreateInput = {
  modelDefinitionId: Scalars['ID']['input'];
  modelEquipmentItems?: InputMaybe<Array<InputMaybe<ModelEquipmentItemInput>>>;
  name: Scalars['String']['input'];
  sortNumber: Scalars['Int']['input'];
};

export type ModelEquipmentDeletePayload = DeletePayload & {
  __typename?: 'ModelEquipmentDeletePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ModelEquipmentItemInput = {
  categoryId: Scalars['ID']['input'];
  changed: Scalars['Boolean']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentChanged: Scalars['Boolean']['input'];
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  equipmentName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelEquipmentPayload = {
  __typename?: 'ModelEquipmentPayload';
  errors?: Maybe<Array<BusinessError>>;
  modelEquipment?: Maybe<ModelEquipment>;
};

export type ModelEquipmentUpdateInput = {
  id: Scalars['ID']['input'];
  modelEquipmentItems?: InputMaybe<Array<InputMaybe<ModelEquipmentItemInput>>>;
  name: Scalars['String']['input'];
  sortNumber: Scalars['Int']['input'];
};

export type ModelInfo = {
  __typename?: 'ModelInfo';
  brand: Brand;
  line: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelYear: Scalars['Int']['output'];
  vehicleType: VehicleType;
};

export type Mutation = {
  __typename?: 'Mutation';
  changePassword: JwtPayload;
  copyVehicleDefinition?: Maybe<VehicleDefinitionPayload>;
  createBody?: Maybe<BodyPayload>;
  createBonus?: Maybe<BonusPayload>;
  createBrand?: Maybe<BrandPayload>;
  createColor?: Maybe<ColorPayload>;
  createColorType?: Maybe<ColorTypePayload>;
  createCountryOfOrigin?: Maybe<CountryOfOriginPayload>;
  createEquipment?: Maybe<EquipmentPayload>;
  createEquipmentCategory?: Maybe<EquipmentCategoryPayload>;
  createFuelType?: Maybe<FuelTypePayload>;
  createInStoreVehicleCard?: Maybe<VehicleCardPayload>;
  createMarketingTag?: Maybe<MarketingTagPayload>;
  createModelColor?: Maybe<ModelColorPayload>;
  createModelDefinition?: Maybe<ModelDefinitionPayload>;
  createModelEquipment?: Maybe<ModelEquipmentPayload>;
  createModelEquipmentItem?: Maybe<EquipmentItemPayload>;
  createServicePackage?: Maybe<ServicePackagePayload>;
  createTechnicalSpec?: Maybe<TechnicalSpecificationPayload>;
  createTransmissionType?: Maybe<TransmissionTypePayload>;
  createUsedVehicleCard?: Maybe<UsedVehicleCard>;
  createVehicleCard?: Maybe<VehicleCardPayload>;
  createVehicleCardColor?: Maybe<VehicleCardColorPayload>;
  createVehicleCardExtraEquipment?: Maybe<VehicleCardExtraEquipmentPayload>;
  createVehicleCardFinance?: Maybe<VehicleCardFinancePayload>;
  createVehicleCardMarketing?: Maybe<VehicleCardMarketingPayload>;
  createVehicleDefinition?: Maybe<VehicleDefinition>;
  createVehicleType?: Maybe<VehicleTypePayload>;
  createWheelbaseType?: Maybe<WheelbaseTypePayload>;
  deleteImage?: Maybe<ImageDeletePayload>;
  deleteModelColor?: Maybe<ModelColorDeletePayload>;
  deleteModelEquipmentItem?: Maybe<ModelEquipmentDeletePayload>;
  deleteUsedVehicleImage?: Maybe<UsedVehicleImageDeletePayload>;
  deleteVehicleCardColor?: Maybe<CardColorDeletePayload>;
  duplicateUsedVehicleImage?: Maybe<UsedVehicleImagePayload>;
  duplicateVehicleDefinition?: Maybe<VehicleDefinitionPayload>;
  generateAccessToken: JwtPayload;
  importChangedPropertiesResolved?: Maybe<Scalars['Boolean']['output']>;
  importVehicleDefinitions?: Maybe<Scalars['Boolean']['output']>;
  updateArchivedStateVehicleDefinition?: Maybe<VehicleDefinitionPayload>;
  updateBody?: Maybe<BodyPayload>;
  updateBonus?: Maybe<BonusPayload>;
  updateBrand?: Maybe<BrandPayload>;
  updateColor?: Maybe<ColorPayload>;
  updateColorType?: Maybe<ColorTypePayload>;
  updateCountryOfOrigin?: Maybe<CountryOfOriginPayload>;
  updateEquipment?: Maybe<EquipmentPayload>;
  updateEquipmentCategory?: Maybe<EquipmentCategoryPayload>;
  updateFuelType?: Maybe<FuelTypePayload>;
  updateMarketingTag?: Maybe<MarketingTagPayload>;
  updateModelColor?: Maybe<ModelColorPayload>;
  updateModelDefinition?: Maybe<ModelDefinitionPayload>;
  updateModelEquipment?: Maybe<ModelEquipmentPayload>;
  updateModelEquipmentItem?: Maybe<EquipmentItemPayload>;
  updateServicePackage?: Maybe<ServicePackagePayload>;
  updateServicePackageState?: Maybe<ServicePackagePayload>;
  updateTechnicalSpec?: Maybe<TechnicalSpecificationPayload>;
  updateTransmissionType?: Maybe<TransmissionTypePayload>;
  updateUsedVehicleCard?: Maybe<UsedVehicleCardPayload>;
  updateUsedVehicleCardFinance?: Maybe<UsedVehicleCardFinance>;
  updateUsedVehicleCardState?: Maybe<UsedVehicleCardPayload>;
  updateVehicleCard?: Maybe<VehicleCardPayload>;
  updateVehicleCardColor?: Maybe<VehicleCardColorPayload>;
  updateVehicleCardExtraEquipment?: Maybe<VehicleCardExtraEquipmentPayload>;
  updateVehicleCardFinance?: Maybe<VehicleCardFinancePayload>;
  updateVehicleCardMarketing?: Maybe<VehicleCardMarketingPayload>;
  updateVehicleCardState?: Maybe<VehicleCardPayload>;
  updateVehicleDefinition?: Maybe<VehicleDefinitionPayload>;
  updateVehicleType?: Maybe<VehicleTypePayload>;
  updateWheelbaseType?: Maybe<WheelbaseTypePayload>;
  uploadImage?: Maybe<ImagePayload>;
  uploadUsedVehicleImage?: Maybe<UsedVehicleImagePayload>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationCopyVehicleDefinitionArgs = {
  input: VehicleDefinitionCopyInput;
};


export type MutationCreateBodyArgs = {
  input: BodyCreateDto;
};


export type MutationCreateBonusArgs = {
  input: BonusCreateInput;
};


export type MutationCreateBrandArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateColorArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateColorTypeArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateCountryOfOriginArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateEquipmentArgs = {
  input: EquipmentCreateInput;
};


export type MutationCreateEquipmentCategoryArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateFuelTypeArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateInStoreVehicleCardArgs = {
  input: InStoreVehicleCardInput;
};


export type MutationCreateMarketingTagArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateModelColorArgs = {
  input: ModelColorCreateInput;
};


export type MutationCreateModelDefinitionArgs = {
  input: ModelDefinitionCreateInput;
};


export type MutationCreateModelEquipmentArgs = {
  input: ModelEquipmentCreateInput;
};


export type MutationCreateModelEquipmentItemArgs = {
  input: EquipmentItemCreateInput;
};


export type MutationCreateServicePackageArgs = {
  input: ServicePackageCreateInput;
};


export type MutationCreateTechnicalSpecArgs = {
  input: TechnicalSpecificationCreateInput;
};


export type MutationCreateTransmissionTypeArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateUsedVehicleCardArgs = {
  input: UsedVehicleCardInput;
};


export type MutationCreateVehicleCardArgs = {
  input: VehicleCardCreateInput;
};


export type MutationCreateVehicleCardColorArgs = {
  input: VehicleCardColorCreateInput;
};


export type MutationCreateVehicleCardExtraEquipmentArgs = {
  input: VehicleCardExtraEquipmentCreateInput;
};


export type MutationCreateVehicleCardFinanceArgs = {
  input: VehicleCardFinanceCreateInput;
};


export type MutationCreateVehicleCardMarketingArgs = {
  input: VehicleCardMarketingCreateInput;
};


export type MutationCreateVehicleTypeArgs = {
  input: CodetableCreateDto;
};


export type MutationCreateWheelbaseTypeArgs = {
  input: CodetableCreateDto;
};


export type MutationDeleteImageArgs = {
  input: ImageDeleteInput;
};


export type MutationDeleteModelColorArgs = {
  input: ModelColorDeleteInput;
};


export type MutationDeleteModelEquipmentItemArgs = {
  input: EquipmentItemDeleteInput;
};


export type MutationDeleteUsedVehicleImageArgs = {
  input: UsedVehicleImageDeleteInput;
};


export type MutationDeleteVehicleCardColorArgs = {
  input: VehicleCardColorDeleteInput;
};


export type MutationDuplicateUsedVehicleImageArgs = {
  input: UsedVehicleImageDuplicateInput;
};


export type MutationDuplicateVehicleDefinitionArgs = {
  input: VehicleDefinitionDuplicateInput;
};


export type MutationGenerateAccessTokenArgs = {
  input?: InputMaybe<GenerateAccessTokenInput>;
};


export type MutationImportChangedPropertiesResolvedArgs = {
  vin: Scalars['String']['input'];
};


export type MutationImportVehicleDefinitionsArgs = {
  input: Array<UsedVehicleImportDefinition>;
  seller: UsedVehicleSellerInput;
};


export type MutationUpdateArchivedStateVehicleDefinitionArgs = {
  input: VehicleDefinitionArchivedStateUpdateInput;
};


export type MutationUpdateBodyArgs = {
  input: BodyUpdateDto;
};


export type MutationUpdateBonusArgs = {
  input: BonusUpdateInput;
};


export type MutationUpdateBrandArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateColorArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateColorTypeArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateCountryOfOriginArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateEquipmentArgs = {
  input: EquipmentUpdateInput;
};


export type MutationUpdateEquipmentCategoryArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateFuelTypeArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateMarketingTagArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateModelColorArgs = {
  input: ModelColorUpdateInput;
};


export type MutationUpdateModelDefinitionArgs = {
  input: ModelDefinitionUpdateInput;
};


export type MutationUpdateModelEquipmentArgs = {
  input: ModelEquipmentUpdateInput;
};


export type MutationUpdateModelEquipmentItemArgs = {
  input: EquipmentItemUpdateInput;
};


export type MutationUpdateServicePackageArgs = {
  input: ServicePackageUpdateInput;
};


export type MutationUpdateServicePackageStateArgs = {
  input: ServicePackageStateUpdateInput;
};


export type MutationUpdateTechnicalSpecArgs = {
  input: TechnicalSpecificationUpdateInput;
};


export type MutationUpdateTransmissionTypeArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateUsedVehicleCardArgs = {
  input: UsedVehicleCardUpdateInput;
};


export type MutationUpdateUsedVehicleCardFinanceArgs = {
  id: Scalars['ID']['input'];
  input: UsedVehicleCardFinanceInput;
};


export type MutationUpdateUsedVehicleCardStateArgs = {
  input: UsedVehicleCardStateUpdateInput;
};


export type MutationUpdateVehicleCardArgs = {
  input: VehicleCardUpdateInput;
};


export type MutationUpdateVehicleCardColorArgs = {
  input: VehicleCardColorUpdateInput;
};


export type MutationUpdateVehicleCardExtraEquipmentArgs = {
  input: VehicleCardExtraEquipmentUpdateInput;
};


export type MutationUpdateVehicleCardFinanceArgs = {
  input: VehicleCardFinanceUpdateInput;
};


export type MutationUpdateVehicleCardMarketingArgs = {
  input: VehicleCardMarketingUpdateInput;
};


export type MutationUpdateVehicleCardStateArgs = {
  input: VehicleCardStateUpdateInput;
};


export type MutationUpdateVehicleDefinitionArgs = {
  input: VehicleDefinitionUpdateInput;
};


export type MutationUpdateVehicleTypeArgs = {
  input: CodetableUpdateDto;
};


export type MutationUpdateWheelbaseTypeArgs = {
  input: CodetableUpdateDto;
};


export type MutationUploadImageArgs = {
  input: ImageUploadInput;
};


export type MutationUploadUsedVehicleImageArgs = {
  input: UsedVehicleImageUploadInput;
};

export type NvDefinitionDistinctModelInfoPage = {
  __typename?: 'NVDefinitionDistinctModelInfoPage';
  data: Array<ModelInfo>;
};

export type NewVehicleCardFeedFilter = {
  bodyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fuelTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lines?: InputMaybe<Array<Scalars['String']['input']>>;
  modelYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  updated?: InputMaybe<DateTimeFilter>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum ParamTypeEnum {
  Edit = 'EDIT',
  Select = 'SELECT'
}

export type PriceFilter = {
  from?: InputMaybe<Scalars['BigDecimal']['input']>;
  to?: InputMaybe<Scalars['BigDecimal']['input']>;
};

export type Query = {
  __typename?: 'Query';
  calculateVehicleFinance: CalculationPayload;
  getBodies: Array<Body>;
  getBody: Body;
  getBonuses: Array<Bonus>;
  getBrand: Brand;
  getBrands: Array<Brand>;
  getColor: Color;
  getColorType: ColorType;
  getColorTypes: Array<ColorType>;
  getColors: Array<Color>;
  getCountriesOfOrigin: Array<CountryOfOrigin>;
  getCountryOfOrigin: CountryOfOrigin;
  getEngines?: Maybe<Array<Scalars['String']['output']>>;
  getEquipmentCategories: Array<EquipmentCategory>;
  getEquipmentCategory: EquipmentCategory;
  getEquipments: Array<Equipment>;
  /** This query returns available finance products by 3rd party finance system. */
  getFinanceProducts: Array<FinanceProduct>;
  getFuelType: FuelType;
  getFuelTypes: Array<FuelType>;
  getImage?: Maybe<Image>;
  getImportedVehicleDefinition: ImportedUsedVehicleDefinition;
  getImportedVehicleDefinitions: ImportedVehicleDefinitionPage;
  getMarketingTag: MarketingTag;
  getMarketingTags: Array<MarketingTag>;
  getModelDefinitionBrands: Array<Brand>;
  getModelDefinitionLines: Array<Scalars['String']['output']>;
  getModelDefinitionModelYears: Array<Scalars['Int']['output']>;
  getModelDefinitionModels: Array<Scalars['String']['output']>;
  getModelDefinitions: Array<ModelDefinition>;
  getModelEquipmentNames: Array<Scalars['String']['output']>;
  getModelEquipments: Array<ModelEquipment>;
  /**
   * Get distinct list of Model Info using Model Definition
   * - Brand
   * - Model
   * - Line
   * - ModeYear
   * - VehicleType
   */
  getNVDefinitionDistinctModelInfos: NvDefinitionDistinctModelInfoPage;
  getServicePackage: ServicePackage;
  getServicePackages: Array<ServicePackage>;
  getTransmissionType: TransmissionType;
  getTransmissionTypes: Array<TransmissionType>;
  /** This query returns partial data (brand, model, modelYear, line, vehicleType) of Used Vehicle Definition Model with Used Vehicle Card status APPROVED or PUBLISHED. */
  getUVDefinitionDistinctModelInfos: UvDefinitionDistinctModelInfoPage;
  getUsedVehicleCard: UsedVehicleCard;
  getUsedVehicleCardFinanceToRecalculate: Array<UsedVehicleCardFinance>;
  getUsedVehicleCards: UsedVehicleCardPage;
  /**
   * This query returns UsedVehicleCards with status APPROVED or PUBLISHED.
   * Maximal limit value is set to 1000 entries.
   */
  getUsedVehicleFeedCards: UsedVehicleFeedCardPage;
  getVehicleCard?: Maybe<VehicleCard>;
  getVehicleCards: VehicleCardPage;
  getVehicleCardsFeed: VehicleCardPage;
  getVehicleDefinition?: Maybe<VehicleDefinition>;
  getVehicleDefinitions: VehicleDefinitionPage;
  getVehicleType: VehicleType;
  getVehicleTypes: Array<VehicleType>;
  getWheelbaseType: WheelbaseType;
  getWheelbaseTypes: Array<WheelbaseType>;
};


export type QueryCalculateVehicleFinanceArgs = {
  input: CalculationInput;
  productId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBodiesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetBodyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBonusesArgs = {
  filter?: InputMaybe<BonusFilter>;
};


export type QueryGetBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBrandsArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetColorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetColorTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetColorTypesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetColorsArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetCountriesOfOriginArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetCountryOfOriginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEquipmentCategoriesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetEquipmentCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFinanceProductsArgs = {
  input: CalculationProductsInput;
};


export type QueryGetFuelTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFuelTypesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetImportedVehicleDefinitionArgs = {
  vin: Scalars['String']['input'];
};


export type QueryGetImportedVehicleDefinitionsArgs = {
  filter?: InputMaybe<ImportedVehicleDefinitionFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMarketingTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMarketingTagsArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetModelEquipmentNamesArgs = {
  modelDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetModelEquipmentsArgs = {
  modelDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetServicePackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetServicePackagesArgs = {
  filter?: InputMaybe<ServicePackageFilter>;
};


export type QueryGetTransmissionTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTransmissionTypesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetUsedVehicleCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUsedVehicleCardsArgs = {
  filter?: InputMaybe<UsedVehicleCardFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUsedVehicleFeedCardsArgs = {
  filter?: InputMaybe<UsedVehicleFeedCardFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVehicleCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVehicleCardsArgs = {
  filter?: InputMaybe<VehicleCardFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortBy>>;
};


export type QueryGetVehicleCardsFeedArgs = {
  filter?: InputMaybe<NewVehicleCardFeedFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVehicleDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVehicleDefinitionsArgs = {
  filter?: InputMaybe<VehicleDefinitionFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SortBy>>;
};


export type QueryGetVehicleTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVehicleTypesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};


export type QueryGetWheelbaseTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWheelbaseTypesArgs = {
  states?: InputMaybe<Array<CodetableStateEnum>>;
};

export type ResponsePayload = {
  errors?: Maybe<Array<BusinessError>>;
};

export type ServicePackage = {
  __typename?: 'ServicePackage';
  auditInfo?: Maybe<AuditInfo>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  services: Array<Scalars['String']['output']>;
  state: ServicePackageStateEnum;
};

export type ServicePackageCreateInput = {
  items: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePackageFilter = {
  states?: InputMaybe<Array<ServicePackageStateEnum>>;
};

export type ServicePackagePayload = ResponsePayload & {
  __typename?: 'ServicePackagePayload';
  errors?: Maybe<Array<BusinessError>>;
  servicePackage?: Maybe<ServicePackage>;
};

export enum ServicePackageStateEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ServicePackageStateUpdateInput = {
  id: Scalars['ID']['input'];
  state: ServicePackageStateEnum;
};

export type ServicePackageUpdateInput = {
  id: Scalars['ID']['input'];
  items: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SortBy = {
  key: Scalars['String']['input'];
  sort: SortEnum;
};

export enum SortEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TechnicalSpecification = {
  __typename?: 'TechnicalSpecification';
  auditInfo: AuditInfo;
  body: Body;
  cubicCapacity: Scalars['Float']['output'];
  driveWheel: Scalars['String']['output'];
  emission: Scalars['Float']['output'];
  engine: Scalars['String']['output'];
  fourDriveWheel: Scalars['Boolean']['output'];
  fuelConsumption: Scalars['Float']['output'];
  fuelType: FuelType;
  id: Scalars['ID']['output'];
  modelKey: Scalars['String']['output'];
  modelKeyExtension?: Maybe<Scalars['String']['output']>;
  numberOfPallets?: Maybe<Scalars['Int']['output']>;
  optionCode: Scalars['String']['output'];
  power: Scalars['String']['output'];
  price: Scalars['BigDecimal']['output'];
  range?: Maybe<Scalars['Int']['output']>;
  seats: Scalars['Int']['output'];
  transmission: Scalars['String']['output'];
  transmissionType: TransmissionType;
  trunkLength?: Maybe<Scalars['Float']['output']>;
  trunkSpace?: Maybe<Scalars['Float']['output']>;
  wheelbase?: Maybe<WheelbaseType>;
};

export type TechnicalSpecificationCreateInput = {
  body: Scalars['ID']['input'];
  cubicCapacity: Scalars['Float']['input'];
  driveWheel: Scalars['String']['input'];
  emission: Scalars['Float']['input'];
  engine: Scalars['String']['input'];
  fourDriveWheel: Scalars['Boolean']['input'];
  fuelConsumption: Scalars['Float']['input'];
  fuelType: Scalars['ID']['input'];
  modelEquipmentId: Scalars['ID']['input'];
  modelKey: Scalars['String']['input'];
  modelKeyExtension?: InputMaybe<Scalars['String']['input']>;
  numberOfPallets?: InputMaybe<Scalars['Int']['input']>;
  optionCode: Scalars['String']['input'];
  power: Scalars['String']['input'];
  price: Scalars['BigDecimal']['input'];
  range?: InputMaybe<Scalars['Int']['input']>;
  seats: Scalars['Int']['input'];
  transmission: Scalars['String']['input'];
  transmissionType: Scalars['ID']['input'];
  trunkLength?: InputMaybe<Scalars['Float']['input']>;
  trunkSpace?: InputMaybe<Scalars['Float']['input']>;
  wheelbase?: InputMaybe<Scalars['ID']['input']>;
};

export type TechnicalSpecificationPayload = ResponsePayload & {
  __typename?: 'TechnicalSpecificationPayload';
  errors?: Maybe<Array<BusinessError>>;
  technicalSpecification?: Maybe<TechnicalSpecification>;
};

export type TechnicalSpecificationUpdateInput = {
  body: Scalars['ID']['input'];
  cubicCapacity: Scalars['Float']['input'];
  driveWheel: Scalars['String']['input'];
  emission: Scalars['Float']['input'];
  engine: Scalars['String']['input'];
  fourDriveWheel: Scalars['Boolean']['input'];
  fuelConsumption: Scalars['Float']['input'];
  fuelType: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  modelKey: Scalars['String']['input'];
  modelKeyExtension?: InputMaybe<Scalars['String']['input']>;
  numberOfPallets?: InputMaybe<Scalars['Int']['input']>;
  optionCode: Scalars['String']['input'];
  power: Scalars['String']['input'];
  price: Scalars['BigDecimal']['input'];
  range?: InputMaybe<Scalars['Int']['input']>;
  seats: Scalars['Int']['input'];
  transmission: Scalars['String']['input'];
  transmissionType: Scalars['ID']['input'];
  trunkLength?: InputMaybe<Scalars['Float']['input']>;
  trunkSpace?: InputMaybe<Scalars['Float']['input']>;
  wheelbase?: InputMaybe<Scalars['ID']['input']>;
};

export type TransmissionType = CodetableDto & {
  __typename?: 'TransmissionType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type TransmissionTypePayload = ResponsePayload & {
  __typename?: 'TransmissionTypePayload';
  data?: Maybe<TransmissionType>;
  errors?: Maybe<Array<BusinessError>>;
};

export type UvDefinitionDistinctModelInfoPage = {
  __typename?: 'UVDefinitionDistinctModelInfoPage';
  data: Array<ModelInfo>;
};

export type UsedVehicleCard = {
  __typename?: 'UsedVehicleCard';
  created: Scalars['LocalDateTime']['output'];
  createdBy: Scalars['String']['output'];
  externalSourceSystem?: Maybe<ExternalSystem>;
  extraEquipment?: Maybe<UsedVehicleCardExtraEquipment>;
  finance?: Maybe<UsedVehicleCardFinance>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<UsedVehicleImage>>;
  importData?: Maybe<ImportedUsedVehicleDefinition>;
  marketing?: Maybe<UsedVehicleCardMarketing>;
  publishedExternalSystem?: Maybe<Array<ExternalSystem>>;
  seller?: Maybe<UsedVehicleSeller>;
  state: UsedVehicleCardStateEnum;
  updated?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleDefinition: UsedVehicleDefinition;
};

export type UsedVehicleCardCreateInput = {
  card?: InputMaybe<UsedVehicleCardInput>;
};

export type UsedVehicleCardExtraEquipment = {
  __typename?: 'UsedVehicleCardExtraEquipment';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ExtraEquipmentItem>>;
};

export type UsedVehicleCardExtraEquipmentPayload = ResponsePayload & {
  __typename?: 'UsedVehicleCardExtraEquipmentPayload';
  errors?: Maybe<Array<BusinessError>>;
  extraEquipment?: Maybe<UsedVehicleCardExtraEquipment>;
};

export type UsedVehicleCardExtraEquipmentUpdateInput = {
  extraEquipmentId: Scalars['ID']['input'];
  items?: InputMaybe<Array<ExtraEquipmentItemInput>>;
};

export type UsedVehicleCardFilter = {
  brand?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<UsedVehicleCardStateEnum>>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type UsedVehicleCardFinance = {
  __typename?: 'UsedVehicleCardFinance';
  autoCmsDiscountCRN?: Maybe<Scalars['BigDecimal']['output']>;
  autoCmsDiscountPP?: Maybe<Scalars['BigDecimal']['output']>;
  bonuses?: Maybe<Array<Bonus>>;
  coinsurance?: Maybe<Scalars['Float']['output']>;
  credit?: Maybe<Credit>;
  deferredCredit?: Maybe<DeferredCredit>;
  id: Scalars['ID']['output'];
  lease?: Maybe<Leasing>;
};

export type UsedVehicleCardFinanceInput = {
  autoCmsDiscountCRN?: InputMaybe<Scalars['BigDecimal']['input']>;
  autoCmsDiscountPP?: InputMaybe<Scalars['BigDecimal']['input']>;
  bonusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coinsurance?: InputMaybe<Scalars['Float']['input']>;
  credit?: InputMaybe<CreditInput>;
  deferredCredit?: InputMaybe<DeferredCreditInput>;
  lease?: InputMaybe<LeasingInput>;
};

export type UsedVehicleCardInput = {
  externalSourceSystem?: InputMaybe<ExternalSystemInput>;
  extraEquipment?: InputMaybe<Array<ExtraEquipmentItemInput>>;
  finance?: InputMaybe<UsedVehicleCardFinanceInput>;
  images?: InputMaybe<Array<UsedVehicleImageInput>>;
  marketing?: InputMaybe<UsedVehicleCardMarketingInput>;
  publishedExternalSystem?: InputMaybe<Array<ExternalSystemInput>>;
  seller?: InputMaybe<UsedVehicleSellerInput>;
  state: UsedVehicleCardStateEnum;
  vehicleDefinition: UsedVehicleDefinitionInput;
};

export type UsedVehicleCardMarketing = {
  __typename?: 'UsedVehicleCardMarketing';
  id: Scalars['ID']['output'];
  marketingTags?: Maybe<Array<MarketingTag>>;
};

export type UsedVehicleCardMarketingInput = {
  marketingTags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UsedVehicleCardPage = {
  __typename?: 'UsedVehicleCardPage';
  data: Array<UsedVehicleCard>;
  pageInfo: PageInfo;
};

export type UsedVehicleCardPayload = ResponsePayload & {
  __typename?: 'UsedVehicleCardPayload';
  errors?: Maybe<Array<BusinessError>>;
  usedVehicleCard?: Maybe<UsedVehicleCard>;
};

export enum UsedVehicleCardStateEnum {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AwaitApproval = 'AWAIT_APPROVAL',
  InProgress = 'IN_PROGRESS',
  Published = 'PUBLISHED',
  Sold = 'SOLD',
  Unarchive = 'UNARCHIVE'
}

export type UsedVehicleCardStateUpdateInput = {
  cardId: Scalars['ID']['input'];
  state: UsedVehicleCardStateEnum;
};

export type UsedVehicleCardUpdateInput = {
  card?: InputMaybe<UsedVehicleCardInput>;
  id: Scalars['ID']['input'];
};

export type UsedVehicleColor = {
  __typename?: 'UsedVehicleColor';
  color: Color;
  colorType: ColorType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UsedVehicleColorInput = {
  color: Scalars['ID']['input'];
  colorType: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UsedVehicleDefinition = {
  __typename?: 'UsedVehicleDefinition';
  auctionPrice?: Maybe<Scalars['Float']['output']>;
  body: Body;
  brand: Brand;
  color?: Maybe<UsedVehicleColor>;
  countryOfOrigin?: Maybe<CountryOfOrigin>;
  /** @deprecated created is deprecated. Does not hold any value. */
  created?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated createdBy is deprecated. Does not hold any value. */
  createdBy?: Maybe<Scalars['String']['output']>;
  cubicCapacity: Scalars['Float']['output'];
  cubicCapacityDescription?: Maybe<Scalars['String']['output']>;
  currency: CurrencyEnum;
  customAttributes?: Maybe<Array<CustomAttribute>>;
  doorsNumber?: Maybe<Scalars['Int']['output']>;
  driveWheel: Scalars['String']['output'];
  emission: Scalars['Float']['output'];
  emissionUntil?: Maybe<Scalars['Date']['output']>;
  engine: Scalars['String']['output'];
  equipment?: Maybe<UsedVehicleEquipment>;
  fourDriveWheel: Scalars['Boolean']['output'];
  fuelConsumption: Scalars['Float']['output'];
  fuelType: FuelType;
  id: Scalars['ID']['output'];
  intoOperation?: Maybe<Scalars['Date']['output']>;
  line: Scalars['String']['output'];
  mileage: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  modelKey?: Maybe<Scalars['String']['output']>;
  modelKeyExtension?: Maybe<Scalars['String']['output']>;
  modelYear: Scalars['Int']['output'];
  newVehiclePrice?: Maybe<Scalars['Float']['output']>;
  noCrashFlag?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfPallets?: Maybe<Scalars['Int']['output']>;
  ownerCount: Scalars['Int']['output'];
  power: Scalars['String']['output'];
  price: Scalars['BigDecimal']['output'];
  range?: Maybe<Scalars['Int']['output']>;
  refVehicle?: Maybe<Scalars['Boolean']['output']>;
  seats: Scalars['Int']['output'];
  serviceBookFlag?: Maybe<Scalars['Boolean']['output']>;
  shifts?: Maybe<Scalars['Int']['output']>;
  stkUntil?: Maybe<Scalars['Date']['output']>;
  transmission: Scalars['String']['output'];
  transmissionType: TransmissionType;
  trunkLength?: Maybe<Scalars['Float']['output']>;
  trunkSpace?: Maybe<Scalars['Float']['output']>;
  /** @deprecated updated is deprecated. Does not hold any value. */
  updated?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated updatedBy is deprecated. Does not hold any value. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  vatExpelFlag?: Maybe<Scalars['Boolean']['output']>;
  vehicleState?: Maybe<Scalars['String']['output']>;
  vehicleType: VehicleType;
  vin: Scalars['String']['output'];
  wheelbase?: Maybe<WheelbaseType>;
};

export type UsedVehicleDefinitionInput = {
  auctionPrice?: InputMaybe<Scalars['Float']['input']>;
  body: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  color?: InputMaybe<UsedVehicleColorInput>;
  countryOfOrigin?: InputMaybe<Scalars['ID']['input']>;
  cubicCapacity: Scalars['Float']['input'];
  cubicCapacityDescription?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  doorsNumber?: InputMaybe<Scalars['Int']['input']>;
  driveWheel: Scalars['String']['input'];
  emission: Scalars['Float']['input'];
  emissionUntil?: InputMaybe<Scalars['Date']['input']>;
  engine: Scalars['String']['input'];
  equipment?: InputMaybe<UsedVehicleEquipmentInput>;
  fourDriveWheel: Scalars['Boolean']['input'];
  fuelConsumption: Scalars['Float']['input'];
  fuelType: Scalars['ID']['input'];
  intoOperation?: InputMaybe<Scalars['Date']['input']>;
  line: Scalars['String']['input'];
  mileage: Scalars['Int']['input'];
  model: Scalars['String']['input'];
  modelKey?: InputMaybe<Scalars['String']['input']>;
  modelKeyExtension?: InputMaybe<Scalars['String']['input']>;
  modelYear: Scalars['Int']['input'];
  newVehiclePrice?: InputMaybe<Scalars['Float']['input']>;
  noCrashFlag?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfPallets?: InputMaybe<Scalars['Int']['input']>;
  ownerCount: Scalars['Int']['input'];
  power: Scalars['String']['input'];
  price: Scalars['BigDecimal']['input'];
  range?: InputMaybe<Scalars['Int']['input']>;
  refVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  seats: Scalars['Int']['input'];
  serviceBookFlag?: InputMaybe<Scalars['Boolean']['input']>;
  shifts?: InputMaybe<Scalars['Int']['input']>;
  stkUntil?: InputMaybe<Scalars['Date']['input']>;
  transmission: Scalars['String']['input'];
  transmissionType: Scalars['ID']['input'];
  trunkLength?: InputMaybe<Scalars['Float']['input']>;
  trunkSpace?: InputMaybe<Scalars['Float']['input']>;
  vatExpelFlag?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleState?: InputMaybe<Scalars['String']['input']>;
  vehicleType: Scalars['ID']['input'];
  vin: Scalars['String']['input'];
  wheelbase?: InputMaybe<Scalars['ID']['input']>;
};

export type UsedVehicleEquipment = {
  __typename?: 'UsedVehicleEquipment';
  equipments?: Maybe<Array<UsedVehicleEquipmentItem>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UsedVehicleEquipmentInput = {
  equipments?: InputMaybe<Array<UsedVehicleEquipmentItemInput>>;
  name: Scalars['String']['input'];
};

export type UsedVehicleEquipmentItem = {
  __typename?: 'UsedVehicleEquipmentItem';
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  equipment: Equipment;
};

export type UsedVehicleEquipmentItemInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['ID']['input'];
};

export type UsedVehicleFeedCard = {
  __typename?: 'UsedVehicleFeedCard';
  created: Scalars['LocalDateTime']['output'];
  extraEquipment?: Maybe<UsedVehicleCardExtraEquipment>;
  finance?: Maybe<UsedVehicleCardFinance>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<UsedVehicleImage>>;
  marketing?: Maybe<UsedVehicleCardMarketing>;
  seller?: Maybe<UsedVehicleSeller>;
  updated?: Maybe<Scalars['LocalDateTime']['output']>;
  vehicleDefinition: UsedVehicleDefinition;
};

export type UsedVehicleFeedCardFilter = {
  bodyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fuelTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lines?: InputMaybe<Array<Scalars['String']['input']>>;
  modelYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters result data using attribute UsedVehicleCard#updated from passed date-time. Expects ISO 8601 format. */
  updatedFrom?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Filters result data using attribute UsedVehicleCard#updated to passed date-time. Expects ISO 8601 format. */
  updatedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
  vehicleStates?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsedVehicleFeedCardPage = {
  __typename?: 'UsedVehicleFeedCardPage';
  data: Array<UsedVehicleFeedCard>;
  pageInfo: PageInfo;
};

export type UsedVehicleImage = {
  __typename?: 'UsedVehicleImage';
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mainImage?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  publicUrl: Scalars['String']['output'];
};

export type UsedVehicleImageDeleteInput = {
  fileName: Scalars['String']['input'];
  /**
   * fileName consists of image ID and original image extension
   * eg.: 349d5bda-0741-4b9c-b9d3-8476818b86ad.png
   */
  imageId: Scalars['ID']['input'];
};

export type UsedVehicleImageDeletePayload = DeletePayload & {
  __typename?: 'UsedVehicleImageDeletePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UsedVehicleImageDuplicateInput = {
  fileName: Scalars['String']['input'];
};

export type UsedVehicleImageInput = {
  fileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  mainImage?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  publicUrl: Scalars['String']['input'];
};

export type UsedVehicleImagePayload = ResponsePayload & {
  __typename?: 'UsedVehicleImagePayload';
  errors?: Maybe<Array<BusinessError>>;
  fileName: Scalars['String']['output'];
  imageId: Scalars['ID']['output'];
  publicUrl: Scalars['String']['output'];
};

export type UsedVehicleImageUploadInput = {
  content: Scalars['String']['input'];
};

export type UsedVehicleImportDefinition = {
  auctionPrice?: InputMaybe<Scalars['Float']['input']>;
  body?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['ID']['input']>;
  cubicCapacity?: InputMaybe<Scalars['Float']['input']>;
  cubicCapacityDescription?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  doorsNumber?: InputMaybe<Scalars['Int']['input']>;
  driveWheel?: InputMaybe<Scalars['String']['input']>;
  emission?: InputMaybe<Scalars['Float']['input']>;
  emissionUntil?: InputMaybe<Scalars['Date']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['JsonValue']['input']>;
  fourDriveWheel?: InputMaybe<Scalars['Boolean']['input']>;
  fuelConsumption?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<Scalars['ID']['input']>;
  imageUrls: Array<Scalars['String']['input']>;
  importAdvertisementUrl: Scalars['String']['input'];
  importedFromSystem: Scalars['String']['input'];
  intoOperation?: InputMaybe<Scalars['Date']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  mileage: Scalars['Int']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  modelKey?: InputMaybe<Scalars['String']['input']>;
  modelKeyExtension?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  newVehiclePrice?: InputMaybe<Scalars['Float']['input']>;
  noCrashFlag?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfPallets?: InputMaybe<Scalars['Int']['input']>;
  ownerCount: Scalars['Int']['input'];
  power?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['BigDecimal']['input'];
  range?: InputMaybe<Scalars['Int']['input']>;
  refVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  serviceBookFlag?: InputMaybe<Scalars['Boolean']['input']>;
  shifts?: InputMaybe<Scalars['Int']['input']>;
  stkUntil?: InputMaybe<Scalars['Date']['input']>;
  transmission?: InputMaybe<Scalars['String']['input']>;
  transmissionType?: InputMaybe<Scalars['ID']['input']>;
  trunkLength?: InputMaybe<Scalars['Float']['input']>;
  trunkSpace?: InputMaybe<Scalars['Float']['input']>;
  vatExpelFlag?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleState?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<Scalars['ID']['input']>;
  vin: Scalars['String']['input'];
  wheelbase?: InputMaybe<Scalars['ID']['input']>;
};

export type UsedVehicleMainImageUpdateInput = {
  cardId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
};

export type UsedVehicleMainImageUpdatePayload = DeletePayload & {
  __typename?: 'UsedVehicleMainImageUpdatePayload';
  errors?: Maybe<Array<BusinessError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UsedVehicleSeller = {
  __typename?: 'UsedVehicleSeller';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UsedVehicleSellerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleCard = {
  __typename?: 'VehicleCard';
  auditInfo: AuditInfo;
  colors?: Maybe<Array<VehicleCardColor>>;
  commission: Scalars['String']['output'];
  definition?: Maybe<VehicleDefinition>;
  deliveryDate?: Maybe<VehicleDelivery>;
  extraEquipment?: Maybe<VehicleCardExtraEquipment>;
  finance?: Maybe<VehicleCardFinance>;
  id: Scalars['ID']['output'];
  inStoreCard: Scalars['Boolean']['output'];
  marketing?: Maybe<VehicleCardMarketing>;
  offerValidTo?: Maybe<Scalars['LocalDate']['output']>;
  sourceCardId?: Maybe<Scalars['ID']['output']>;
  state: VehicleCardStateEnum;
};

export type VehicleCardColor = {
  __typename?: 'VehicleCardColor';
  commissionColorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<ImageBasic>>;
  mainImageId?: Maybe<Scalars['ID']['output']>;
  modelColor: ModelColor;
};

export type VehicleCardColorCreateInput = {
  cardId: Scalars['ID']['input'];
  modelColorId: Scalars['ID']['input'];
};

export type VehicleCardColorDeleteInput = {
  cardColorId: Scalars['ID']['input'];
};

export type VehicleCardColorPayload = ResponsePayload & {
  __typename?: 'VehicleCardColorPayload';
  cardColor?: Maybe<VehicleCardColor>;
  errors?: Maybe<Array<BusinessError>>;
};

export type VehicleCardColorUpdateInput = {
  cardColorId: Scalars['ID']['input'];
  mainImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type VehicleCardCreateInput = {
  commission: Scalars['String']['input'];
  definitionId: Scalars['ID']['input'];
  deliveryDate?: InputMaybe<VehicleDeliveryInput>;
  offerValidTo?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type VehicleCardExtraEquipment = {
  __typename?: 'VehicleCardExtraEquipment';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ExtraEquipmentItem>>;
};

export type VehicleCardExtraEquipmentCreateInput = {
  cardId: Scalars['ID']['input'];
  items?: InputMaybe<Array<ExtraEquipmentItemInput>>;
};

export type VehicleCardExtraEquipmentPayload = ResponsePayload & {
  __typename?: 'VehicleCardExtraEquipmentPayload';
  errors?: Maybe<Array<BusinessError>>;
  extraEquipment?: Maybe<VehicleCardExtraEquipment>;
};

export type VehicleCardExtraEquipmentUpdateInput = {
  extraEquipmentId: Scalars['ID']['input'];
  items?: InputMaybe<Array<ExtraEquipmentItemInput>>;
};

export type VehicleCardFilter = {
  automaticFinanceCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<Array<Scalars['ID']['input']>>;
  commission?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<DateFilter>;
  engine?: InputMaybe<Array<Scalars['String']['input']>>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  financeType?: InputMaybe<Array<FinanceTypeEnum>>;
  isInStoreCar?: InputMaybe<Scalars['Boolean']['input']>;
  line?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Array<Scalars['Int']['input']>>;
  offerValidity?: InputMaybe<DateFilter>;
  optionCode?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<PriceFilter>;
  state?: InputMaybe<Array<VehicleCardStateEnum>>;
  updated?: InputMaybe<DateTimeFilter>;
  vehicleType?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VehicleCardFinance = {
  __typename?: 'VehicleCardFinance';
  autoCmsDiscountCRN?: Maybe<Scalars['BigDecimal']['output']>;
  autoCmsDiscountPP?: Maybe<Scalars['BigDecimal']['output']>;
  bonuses?: Maybe<Array<Bonus>>;
  coinsurance?: Maybe<Scalars['Float']['output']>;
  financeGroups?: Maybe<Array<FinanceGroup>>;
  id: Scalars['ID']['output'];
};

export type VehicleCardFinanceCreateInput = {
  autoCmsDiscountCRN?: InputMaybe<Scalars['BigDecimal']['input']>;
  autoCmsDiscountPP?: InputMaybe<Scalars['BigDecimal']['input']>;
  bonusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  cardId: Scalars['ID']['input'];
  coinsurance?: InputMaybe<Scalars['Float']['input']>;
  financeGroups?: InputMaybe<Array<FinanceGroupInput>>;
};

export type VehicleCardFinancePayload = ResponsePayload & {
  __typename?: 'VehicleCardFinancePayload';
  errors?: Maybe<Array<BusinessError>>;
  finance?: Maybe<VehicleCardFinance>;
};

export type VehicleCardFinanceUpdateInput = {
  autoCmsDiscountCRN?: InputMaybe<Scalars['BigDecimal']['input']>;
  autoCmsDiscountPP?: InputMaybe<Scalars['BigDecimal']['input']>;
  bonusIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coinsurance?: InputMaybe<Scalars['Float']['input']>;
  financeGroups?: InputMaybe<Array<FinanceGroupInput>>;
  id: Scalars['ID']['input'];
};

export type VehicleCardMarketing = {
  __typename?: 'VehicleCardMarketing';
  id: Scalars['ID']['output'];
  marketingTags?: Maybe<Array<Scalars['ID']['output']>>;
};

export type VehicleCardMarketingCreateInput = {
  cardId: Scalars['ID']['input'];
  marketingTags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VehicleCardMarketingPayload = ResponsePayload & {
  __typename?: 'VehicleCardMarketingPayload';
  errors?: Maybe<Array<BusinessError>>;
  marketing?: Maybe<VehicleCardMarketing>;
};

export type VehicleCardMarketingUpdateInput = {
  id: Scalars['ID']['input'];
  marketingTags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VehicleCardPage = {
  __typename?: 'VehicleCardPage';
  data: Array<VehicleCard>;
  pageInfo: PageInfo;
};

export type VehicleCardPayload = ResponsePayload & {
  __typename?: 'VehicleCardPayload';
  errors?: Maybe<Array<BusinessError>>;
  vehicleCard?: Maybe<VehicleCard>;
};

export enum VehicleCardStateEnum {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AwaitApproval = 'AWAIT_APPROVAL',
  InProgress = 'IN_PROGRESS',
  Published = 'PUBLISHED',
  Sold = 'SOLD',
  Unarchive = 'UNARCHIVE'
}

export type VehicleCardStateUpdateInput = {
  cardId: Scalars['ID']['input'];
  state: VehicleCardStateEnum;
};

export type VehicleCardUpdateInput = {
  commission: Scalars['String']['input'];
  definitionId: Scalars['ID']['input'];
  deliveryDate?: InputMaybe<VehicleDeliveryInput>;
  id: Scalars['ID']['input'];
  offerValidTo?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type VehicleDefinition = {
  __typename?: 'VehicleDefinition';
  auditInfo: AuditInfo;
  equipment?: Maybe<ModelEquipment>;
  id: Scalars['ID']['output'];
  modelDefinition?: Maybe<ModelDefinition>;
  state: VehicleDefinitionStateEnum;
  vehicleSpec?: Maybe<TechnicalSpecification>;
};

export type VehicleDefinitionArchivedStateUpdateInput = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type VehicleDefinitionCopyInput = {
  id: Scalars['ID']['input'];
  model: ModelDefinitionCopyInput;
};

export type VehicleDefinitionDuplicateInput = {
  equipment?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  modelDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleSpec?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleDefinitionFilter = {
  brand?: InputMaybe<Array<Scalars['ID']['input']>>;
  engine?: InputMaybe<Array<Scalars['String']['input']>>;
  equipment?: InputMaybe<Array<Scalars['ID']['input']>>;
  line?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  modelYear?: InputMaybe<Array<Scalars['Int']['input']>>;
  optionCode?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['BigDecimal']['input']>;
  priceTo?: InputMaybe<Scalars['BigDecimal']['input']>;
  state?: InputMaybe<Array<VehicleDefinitionStateEnum>>;
  updatedFrom?: InputMaybe<Scalars['LocalDateTime']['input']>;
  updatedTo?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type VehicleDefinitionPage = {
  __typename?: 'VehicleDefinitionPage';
  data: Array<VehicleDefinition>;
  pageInfo: PageInfo;
};

export type VehicleDefinitionPayload = ResponsePayload & {
  __typename?: 'VehicleDefinitionPayload';
  errors?: Maybe<Array<BusinessError>>;
  vehicleDefinition?: Maybe<VehicleDefinition>;
};

export enum VehicleDefinitionStateEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  WaitEquipment = 'WAIT_EQUIPMENT',
  WaitModel = 'WAIT_MODEL',
  WaitSpecification = 'WAIT_SPECIFICATION'
}

export type VehicleDefinitionUpdateInput = {
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  modelDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  vehicleSpecId?: InputMaybe<Scalars['ID']['input']>;
};

export type VehicleDelivery = {
  __typename?: 'VehicleDelivery';
  exactDate?: Maybe<Scalars['LocalDate']['output']>;
  immediatePickUp: Scalars['Boolean']['output'];
  plusDays?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDeliveryInput = {
  exactDate?: InputMaybe<Scalars['LocalDate']['input']>;
  immediatePickUp: Scalars['Boolean']['input'];
  plusDays?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleType = CodetableDto & {
  __typename?: 'VehicleType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export enum VehicleTypeEnum {
  Commercial = 'COMMERCIAL',
  Personal = 'PERSONAL'
}

export type VehicleTypePayload = ResponsePayload & {
  __typename?: 'VehicleTypePayload';
  data?: Maybe<VehicleType>;
  errors?: Maybe<Array<BusinessError>>;
};

export type WheelbaseType = CodetableDto & {
  __typename?: 'WheelbaseType';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CodetableStateEnum>;
};

export type WheelbaseTypePayload = ResponsePayload & {
  __typename?: 'WheelbaseTypePayload';
  data?: Maybe<WheelbaseType>;
  errors?: Maybe<Array<BusinessError>>;
};
